import { Box, ButtonBase, ButtonBaseProps, styled } from '@mui/material';
import { DynamicIcon } from 'src/components';

export const Content = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0.5rem 0.5rem 0.5rem 0.8rem',
}));

export const BadgeIconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: -10,
  backgroundColor: theme.palette.custom.OV.sys.inverseOnSurface,
  borderRadius: '50%',
}));

export const StyledBadgeIcon = styled(DynamicIcon)({
  width: '1rem',
  height: '1rem',
  fontSize: '1rem',
});

export const TextContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  flexShrink: 1,
  minWidth: '2rem',
}));

export const DraftClickHandler = styled(ButtonBase, {
  shouldForwardProp: (p) => p !== 'isSelected',
})<{ isSelected?: boolean } & ButtonBaseProps>(({ theme, isSelected }) => ({
  width: '100%',
  maxWidth: '20rem',
  height: '10rem',
  // justifyContent: 'space-between',
  backgroundColor: isSelected ? theme.palette.custom.OV.sys.surfaceContainerHigh : undefined,
  border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  borderRadius: '1rem',
  transition: 'background-color 0.2s',
  '&:hover': { backgroundColor: theme.palette.action.hover },
}));
